<script>
import { Place, City } from '@/api'
import fields from '@/components/fields/'
import FormMixin from '@/crudBases/form/FormMixin'

export default {
  mixins: [FormMixin],
  data() {
    return {
      redirectRoute: { name: 'Place List' }
    }
  },
  methods: {
    getFields() {
      return [
        new fields.Input({
          label: 'Nazwa',
          required: true,
          modelPath: [this, 'form', 'name'],
          multilingual: true
        }),
        new fields.ForeignKey({
          service: City,
          label: 'Miasto',
          modelPath: [this, 'form', 'city'],
          labelField: 'name_pl',
          required: true,
          allowCreate: true
        }),
        new fields.Input({
          label: 'Link do google maps',
          modelPath: [this, 'form', 'url']
        })
      ]
    }
  },
  computed: {
    service() {
      return Place
    }
  }
}
</script>
